const ssn = {
    ssn : {
        value: "",
        dbqName: "F[0].Page_1[0].SocialSecurityNo\\.[0]"
     },
     docName: {
         value: "",
         dbqName: "F[0].#subform[5].TextField8[1]"
     },
     docArea: {
        value: "",
        dbqName: "F[0].#subform[5].TextField8[6]"
    },
     docDate: {
        value : "",
        dbqName: "F[0].#subform[5].TextField8[7]"
    },
     docNpi: {
         value : "",
         dbqName: "F[0].#subform[5].TextField8[3]"
     },
     docPhone: {
        value : "",
        dbqName: "F[0].#subform[5].TextField8[2]"
    },
    docLicenseNo: {
        value : "",
        dbqName: "F[0].#subform[5].TextField8[4]"
    },
    docAddress: {
        value : "",
        dbqName: "F[0].#subform[5].TextField8[5]"
    },
    diagnosisDate : [            
        {
            type: "text",
            dbqName: "F[0].#subform[1].Diagnosis1[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis1[0]",
        },
        {
            type: "text",
            dbqName: "F[0].#subform[1].Diagnosis2[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis[0]",
        },
        {
            type: "text",
            dbqName: "F[0].#subform[1].Diagnosis3[0]",
            dateDbqName: "F[0].#subform[1].DateOfDiagnosis3[0]",
        },       
    ]

}

export default ssn ;